<div class="modal-body">
    @if (currentFilters.length) {
        <h4>
            The generated report will be based upon the following applied
            filters:
        </h4>
        <ul>
            @for (item of currentFilters; track item.key) {
                <li>
                    @switch (item.key) {
                        @case ("responsiblePilot") {
                            <h3>Individual</h3>
                            <p>
                                {{ (item.value | findInList:(userList$ | async))?.label }}
                            </p>
                        }
                        @case ("flightDate") {
                            <h3>Date Range</h3>
                            <p>{{item.value | dateIntervalToString}}</p>
                        }
                        @case ("aircraft") {
                            <h3>{{ 'asset.singular' | term }}</h3>
                            <p>
                                {{ (item.value | findInList:(aircraftList$ | async))?.label }}
                            </p>
                        }
                        @case ("airport") {
                            <h3>Airport</h3>
                            <p>
                                {{ item.value?.icao_code + ' ' + item.value?.name }}
                            </p>
                        }
                        @case ("assessment") {
                            <h3>Form</h3>
                            <p>
                                {{ (item.value | findInList:(formList$ | async))?.label }}
                            </p>
                        }
                    }
                </li>
            }
        </ul>
    }

    <div class="button-bar">
        <button class="btn btn-primary" (click)="confirmExport('pdf')">
            Export Report
        </button>
        <a class="link" (click)="confirmExport('csv')"> Download CSV Data </a>
    </div>
</div>
